export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const YOUTUBE_API_KEY = "AIzaSyA1Mdf5WsuPzKaJyYsZQSlxdZAc_2WFzKQ";
const PLAYLIST_ID = "PLwU9pC2C0PwGIDAQOWfAG3IbsFTKh3Lye"

export const YOU_TUBE_API = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${PLAYLIST_ID}&maxResults=20&key=${YOUTUBE_API_KEY}`
